export enum SolicitacaoTipologiaSituacao {
  Validacao = 1,
  Homologacao = 2,
  Homologada = 3,
  DisponivelMercado = 4,
  Congelada = 5,
}

export enum SolicitacaoTipologiaAcao {
  Validar = 1,
  ConcluirHomologacao = 2,
  DisponibilizarMercado = 3,
}

// Sistemas possíveis para ações de solicitação (espelha o enum do backend)
export enum SolicitacaoSistema {
  CemDelphi = 1,
  CemMobi = 2,
}

// Type helper para compatibilidade com código existente
export type SolicitacaoSistemaString = "CemDelphi" | "CemMobi";

export interface IPagedResponse<T> {
  items: T[];
  page?: number;
  totalPages?: number;
  totalRecords?: number;
  paginate?: boolean;
}

export interface ISolicitacaoTipologiaListaItem {
  idSolicitacao: number;
  numeroSolicitacao: number;
  projetistaId: number;
  projetistaNome: string;
  linhaSistema: string;
  descricao: string;
  quantidadeTipologias: number;
  dataSolicitacao: string;
  situacao: SolicitacaoTipologiaSituacao;
  /** Situação específica para CEM DELPHI. */
  situacaoCemDelphi: SolicitacaoTipologiaSituacao;
  /** Situação específica para CEM MOBI. */
  situacaoCemMobi: SolicitacaoTipologiaSituacao;
  /** Indica se todas as tipologias estão "Excluída do pacote" para CEM DELPHI. */
  todasTipologiasExcluidasCemDelphi?: boolean;
  /** Indica se todas as tipologias estão "Excluída do pacote" para CEM MOBI. */
  todasTipologiasExcluidasCemMobi?: boolean;
  /** Data/hora em que a solicitação foi disponibilizada ao mercado para CEM DELPHI. */
  dataDisponibilizacaoCemDelphi?: string | null;
  /** Data/hora em que a solicitação foi disponibilizada ao mercado para CEM MOBI. */
  dataDisponibilizacaoCemMobi?: string | null;
  /** Caminho do arquivo HTML no Azure Blob Storage para CEM DELPHI. */
  htmlCemDelphiCaminho?: string | null;
  /** Nome do arquivo HTML original enviado para CEM DELPHI. */
  htmlCemDelphiNomeArquivo?: string | null;
  /** Data/hora em que o HTML foi enviado para CEM DELPHI. */
  htmlCemDelphiDataUpload?: string | null;
  /** URL pública do arquivo HTML para CEM DELPHI. */
  htmlCemDelphiUrl?: string | null;
  /** Caminho do arquivo HTML no Azure Blob Storage para CEM MOBI. */
  htmlCemMobiCaminho?: string | null;
  /** Nome do arquivo HTML original enviado para CEM MOBI. */
  htmlCemMobiNomeArquivo?: string | null;
  /** Data/hora em que o HTML foi enviado para CEM MOBI. */
  htmlCemMobiDataUpload?: string | null;
  /** URL pública do arquivo HTML para CEM MOBI. */
  htmlCemMobiUrl?: string | null;
  /** Caminho do arquivo documento_pdf.ZIP no Azure Blob Storage. */
  documentoPdfCaminho?: string | null;
  emergencial: boolean;
  congelada: boolean;
  congeladaPorSolicitacaoId?: number | null;
  vinculada: boolean;
  numeroSolicitacaoAnterior?: number | null;
  numeroSolicitacaoOrigem?: number | null;
  quantidadeTipologiasReenvio: number;
}

export interface ISolicitacaoTipologiaDetalhe {
  idSolicitacao: number;
  numeroSolicitacao: number;
  empresaId: number;
  projetistaId: number;
  projetistaNome: string;
  linhaSistema: string;
  descricaoAtualizacao: string;
  emergencial: boolean;
  dataEmergencial?: string | null;
  responsavelEmergencial?: string | null;
  dataLiberacaoEmergencial?: string | null;
  responsavelLiberacaoEmergencial?: string | null;
  congelada: boolean;
  congeladaPorSolicitacaoId?: number | null;
  situacao: SolicitacaoTipologiaSituacao;
  /** Situação específica para CEM DELPHI. */
  situacaoCemDelphi: SolicitacaoTipologiaSituacao;
  /** Situação específica para CEM MOBI. */
  situacaoCemMobi: SolicitacaoTipologiaSituacao;
  /** Data/hora em que a solicitação foi disponibilizada ao mercado para CEM DELPHI. */
  dataDisponibilizacaoCemDelphi?: string | null;
  /** Data/hora em que a solicitação foi disponibilizada ao mercado para CEM MOBI. */
  dataDisponibilizacaoCemMobi?: string | null;
  /** Nome do usuário que concluiu a homologação. */
  homologacaoResponsavel?: string | null;
  /** IP da máquina do usuário que concluiu a homologação. */
  homologacaoIp?: string | null;
  /** Data/hora em que a homologação foi concluída. */
  homologacaoData?: string | null;
  /** Caminho do arquivo HTML no Azure Blob Storage para CEM DELPHI. */
  htmlCemDelphiCaminho?: string | null;
  /** Nome do arquivo HTML original enviado para CEM DELPHI. */
  htmlCemDelphiNomeArquivo?: string | null;
  /** Data/hora em que o HTML foi enviado para CEM DELPHI. */
  htmlCemDelphiDataUpload?: string | null;
  /** Caminho do arquivo HTML no Azure Blob Storage para CEM MOBI. */
  htmlCemMobiCaminho?: string | null;
  /** Nome do arquivo HTML original enviado para CEM MOBI. */
  htmlCemMobiNomeArquivo?: string | null;
  /** Data/hora em que o HTML foi enviado para CEM MOBI. */
  htmlCemMobiDataUpload?: string | null;
  /** URL pública do arquivo HTML para CEM DELPHI. */
  htmlCemDelphiUrl?: string | null;
  /** URL pública do arquivo HTML para CEM MOBI. */
  htmlCemMobiUrl?: string | null;
  dataEnvio: string;
  nomeArquivo: string;
  caminhoArquivo: string;
  hashArquivo: string;
  observacaoInterna?: string | null;
  solicitacaoAnteriorId?: number | null;
  solicitacaoOrigemId?: number | null;
  numeroSolicitacaoAnterior?: number | null;
  numeroSolicitacaoOrigem: number;
  tipologias: ISolicitacaoTipologiaDetalheItem[];
  historicos: ISolicitacaoTipologiaDetalheHistorico[];
  anexos: ISolicitacaoTipologiaDetalheAnexo[];
  vinculos: ISolicitacaoTipologiaVinculo[];
}

export interface ISolicitacaoTipologiaDetalheItem {
  idItem: number;
  tipologiaId: number;
  codigo: string;
  descricao: string;
  linhaId: number;
  linha: string;
  grupoId?: number | null;
  grupo?: string | null;
  descontinuado: boolean;
  reenvio: boolean;
  solicitacaoAnteriorItemId?: number | null;
  /** Situação geral do item (mantida para compatibilidade). Representa o status mais avançado entre situacaoCemDelphi e situacaoCemMobi. */
  situacao: number;
  /** Situação específica para o sistema CEM DELPHI. */
  situacaoCemDelphi?: number;
  /** Situação específica para o sistema CEM MOBI. */
  situacaoCemMobi?: number;
  substituida: boolean;
  dataVersao?: string | null;
  numeroSolicitacaoDestino?: number | null;
  urlDesenhoSvg?: string | null;
  nomeArquivoDesenho?: string | null;
}

export interface ISolicitacaoTipologiaDetalheHistorico {
  dataEvento: string;
  responsavel: string;
  acao: string;
  situacao: string;
  observacao?: string | null;
}

export interface ISolicitacaoTipologiaDetalheAnexo {
  idAnexo: number;
  nomeArquivo: string;
  caminhoArquivo: string;
  hashArquivo: string;
  dataUpload: string;
}

export interface ISolicitacaoTipologiaVinculo {
  idSolicitacao: number;
  numeroSolicitacao: number;
  situacao: SolicitacaoTipologiaSituacao;
  atual: boolean;
  todasTipologiasSubstituidas: boolean;
  congelada: boolean;
}

